/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Post_MissingInputs */

const en_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This blog post may have been removed or is not published.`)
};

const es_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta publicación del blog puede haberse eliminado o no está publicada.`)
};

const de_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Blogbeitrag wurde möglicherweise entfernt oder wurde nicht veröffentlicht.`)
};

const zh_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这篇博文可能已被删除或未发布。`)
};

const ar_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قد يكون هذا المقال قد أُزيل أو أنه غير منشور.`)
};

const fr_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce billet de blog a peut-être été supprimé ou n'est pas publié.`)
};

const vi_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài viết này có thể đã bị gỡ hoặc chưa được xuất bản.`)
};

const sw_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapisho hili la blogu linaweza kuwa limeondolewa au halijachapishwa.`)
};

const th_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โพสต์ในบล็อกนี้อาจถูกลบออกหรือไม่ได้เผยแพร่`)
};

const bs_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ova blog objava je možda uklonjena ili nije objavljena.`)
};

const ja_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブログ投稿は削除または公開されていない可能性があります。`)
};

const ko_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 블로그 게시물은 제거되거나 게시되지 않습니다.`)
};

const pt_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este post do blog pode ter sido removido ou não foi publicado.`)
};

const it_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo post sul blog potrebbe essere stato rimosso o non è pubblicato.`)
};

const sv_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detta blogginlägg kan ha tagits bort eller inte publiceras.`)
};

const nl_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze blog post kan zijn verwijderd of niet gepubliceerd.`)
};

const da_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette blogindlæg kan være blevet fjernet eller er ikke offentliggjort.`)
};

const nb_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne bloggen kan ha blitt fjernet eller ikke publisert.`)
};

const fi_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä blogikirjoitus on voitu poistaa tai sitä ei julkaista.`)
};

const pl_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten blog post może być usunięty lub nie jest opublikowany.`)
};

const ru_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот блог может быть удален или не опубликован.`)
};

const tr_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu blog yazısı kaldırıldı veya yayınlanmadı.`)
};

const hi_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ब्लॉग पोस्ट को हटाया जा सकता है या प्रकाशित नहीं किया जा सकता है।`)
};

const id_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posting blog ini mungkin telah dihapus atau tidak diterbitkan.`)
};

const ms_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantaran blog ini mungkin telah dipadam atau belum diterbitkan.`)
};

const cs_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento blog post může být odstraněn nebo není zveřejněna.`)
};

const el_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αυτό το blog post μπορεί να έχει αφαιρεθεί ή να μην έχει δημοσιευθεί.`)
};

const he_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפוסט הזה אולי הוסר או לא פורסם.`)
};

const af_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hierdie blogplasing is dalk verwyder of nog nie gepubliseer nie.`)
};

const hu_blog_post_missing = /** @type {(inputs: Blog_Post_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a blog posztot lehet eltávolították, vagy nem tették közzé.`)
};

/**
* | output |
* | --- |
* | "This blog post may have been removed or is not published." |
*
* @param {Blog_Post_MissingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_post_missing = /** @type {((inputs?: Blog_Post_MissingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Post_MissingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_post_missing(inputs)
	if (locale === "de") return de_blog_post_missing(inputs)
	if (locale === "zh") return zh_blog_post_missing(inputs)
	if (locale === "ar") return ar_blog_post_missing(inputs)
	if (locale === "fr") return fr_blog_post_missing(inputs)
	if (locale === "vi") return vi_blog_post_missing(inputs)
	if (locale === "sw") return sw_blog_post_missing(inputs)
	if (locale === "th") return th_blog_post_missing(inputs)
	if (locale === "bs") return bs_blog_post_missing(inputs)
	if (locale === "ja") return ja_blog_post_missing(inputs)
	if (locale === "ko") return ko_blog_post_missing(inputs)
	if (locale === "pt") return pt_blog_post_missing(inputs)
	if (locale === "it") return it_blog_post_missing(inputs)
	if (locale === "sv") return sv_blog_post_missing(inputs)
	if (locale === "nl") return nl_blog_post_missing(inputs)
	if (locale === "da") return da_blog_post_missing(inputs)
	if (locale === "nb") return nb_blog_post_missing(inputs)
	if (locale === "fi") return fi_blog_post_missing(inputs)
	if (locale === "pl") return pl_blog_post_missing(inputs)
	if (locale === "ru") return ru_blog_post_missing(inputs)
	if (locale === "tr") return tr_blog_post_missing(inputs)
	if (locale === "hi") return hi_blog_post_missing(inputs)
	if (locale === "id") return id_blog_post_missing(inputs)
	if (locale === "ms") return ms_blog_post_missing(inputs)
	if (locale === "cs") return cs_blog_post_missing(inputs)
	if (locale === "el") return el_blog_post_missing(inputs)
	if (locale === "he") return he_blog_post_missing(inputs)
	if (locale === "af") return af_blog_post_missing(inputs)
	if (locale === "hu") return hu_blog_post_missing(inputs)
	return en_blog_post_missing(inputs)
});